import { render, staticRenderFns } from "./acu.vue?vue&type=template&id=12a6b6f6&scoped=true&"
import script from "./acu.vue?vue&type=script&lang=js&"
export * from "./acu.vue?vue&type=script&lang=js&"
import style0 from "./acu.vue?vue&type=style&index=0&id=12a6b6f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a6b6f6",
  null
  
)

export default component.exports